import { Type } from '@angular/core';
import { DynamicModel } from './dynamic-model';

export class DynamicItem {
  constructor(
    public component: Type<any>,
    public data: DynamicModel
  ) {}
}
